import { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import Header from "component/Header/Header";
import { useFormik } from "formik";
import { FormControl, TextField, InputLabel } from "@mui/material";
import * as Yup from "yup";
import Button from "@mui/material/Button";
import { resetPassword } from "component/api";
import CheckCircleOutlineSharpIcon from "@mui/icons-material/CheckCircleOutlineSharp";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import "./NuevaContraseña.css";

const NuevaContraseña = () => {
  let getParams = function (url) {
    let params = {};
    let parser = document.createElement("a");
    parser.href = url;
    let query = parser.search.substring(1);
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split("=");
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  };

  const [cuentaContrato, setCuentaContrato] = useState();
  const [hash, setHash] = useState();
  const [messageExito, setMessageExito] = useState(false);
  const [aceptar, setAceptar] = useState(true);
  const [ingresar, setIngresar] = useState(false);
  const [deshabilitar, setDeshabilitar] = useState();
  const [messageError, setMessageError] = useState(false);

  function getParamUrl() {
    setCuentaContrato(getParams(window.location.href).ctaContrato);
    setHash(getParams(window.location.href).hash);
  }
  useEffect(() => {
    try {
      getParamUrl();
    } catch (err) {} //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validation = Yup.object().shape({
    contraseña: Yup.string()
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])/,
        "Debe ser alfanumérica, tener mayúscula, minúscula, y un mínimo de 8 caracteres."
      )
      .min(
        8,
        "Debe ser alfanumérica, tener mayúscula, minúscula, y un mínimo de 8 caracteres."
      )
      .required("Requerido"),
    repetirContraseña: Yup.string()
      .oneOf(
        [Yup.ref("contraseña")],
        "Debe coincidir con la contraseña ingresada."
      )
      .required("Requerido"),
  });
  const formik = useFormik({
    initialValues: {
      cuenta: "",
      contraseña: "",
      repetirContraseña: "",
    },
    validationSchema: validation,
    onSubmit: (values) => {
      const { /* cuenta, */ contraseña /* repetirContraseña */ } = values;
      const obj = {
        cuentaContrato: cuentaContrato,
        contraseña: contraseña,
        hash: hash,
      };
      resetPasswordFunc(obj);
    },
  });

  async function resetPasswordFunc(object) {
    await resetPassword(object)
      .then((response) => {
        setMessageExito(true);
        setAceptar(false);
        setIngresar(true);
        setDeshabilitar(true);
      })
      .catch((err) => {
        setMessageError(true);
      });
  }
  function onChangePassword(password, value) {
    formik.setFieldValue(password, value);
    setMessageError(false);
    setDeshabilitar(false);
  }

  return (
    <div>
      <Header />

      <div>
        <Container maxWidth="sm">
          <br />
          <h1>Nueva contraseña</h1>
          <p>
            Ingresá tu nueva contraseña, recordá que debe ser alfanumérica,
            tener mayúscula, minúscula, y un mínimo de 8 caracteres.
          </p>
          <form
            onSubmit={formik.handleSubmit}
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <FormControl className="form-control-nueva-contraseña">
              <InputLabel style={{ width: "100%" }}>
                <p style={{ color: "black" }}>N° Cuenta </p>
              </InputLabel>
              <br />

              <TextField
                className="text-field-nueva-contraseña"
                onChange={formik.handleChange}
                placeholder={cuentaContrato}
                disabled={true}
                id="cuenta"
                name="cuenta"
                variant="outlined"
                helperText={formik.errors.cuenta}
                error={formik.errors.cuenta}
              />
            </FormControl>
            <FormControl className="form-control-nueva-contraseña">
              <InputLabel style={{ width: "100%" }}>
                <p style={{ color: "black" }}>Contraseña</p>
                <p style={{ color: "grey", whiteSpace: "pre-line" }}>
                  La clave debe ser alfanumérica, tener mayúscula, minúscula, y
                  un mínimo de 8 caracteres.
                </p>
              </InputLabel>
              <br />
              <br />
              <br />
              <br />
              <TextField
                type="password"
                onChange={(event) => {
                  onChangePassword("contraseña", event.target.value);
                }}
                className="text-field-nueva-contraseña"
                style={{
                  marginBottom: "2%",
                }}
                placeholder="Ej: Usuario123"
                disabled={deshabilitar}
                id="contraseña"
                name="contraseña"
                variant="outlined"
                helperText={formik.errors.contraseña}
                error={formik.errors.contraseña}
                sx={{
                  "& .MuiInputBase-root.Mui-disabled": {
                    "& > fieldset": {
                      borderColor: messageExito === true ? "green" : "gray",
                    },
                  },
                }}
              />
            </FormControl>
            <FormControl className="form-control-nueva-contraseña">
              <InputLabel style={{ width: "100%", color: "black" }}>
                Repetir Contraseña
              </InputLabel>
              <TextField
                type="password"
                onChange={(event) => {
                  onChangePassword("repetirContraseña", event.target.value);
                }}
                className="text-field-nueva-contraseña"
                style={{
                  marginBottom: "2%",
                }}
                placeholder="Ej: Usuario123"
                disabled={deshabilitar}
                id="repetirContraseña"
                name="repetirContraseña"
                variant="outlined"
                helperText={formik.errors.repetirContraseña}
                error={formik.errors.repetirContraseña}
                sx={{
                  "& .MuiInputBase-root.Mui-disabled": {
                    "& > fieldset": {
                      borderColor: messageExito === true ? "green" : "gray",
                    },
                  },
                }}
              />
            </FormControl>
            <br />

            {messageError === true && (
              <div
                style={{
                  backgroundColor: "#F9CDD0",
                  border: "red 1px ridge",
                  width: "100%",

                  marginBottom: "10px",
                }}
              >
                <Grid container sx={{ width: "100%" }}>
                  <Grid size={{ xs: 2 }}>
                    <ErrorRoundedIcon
                      fontSize="large"
                      color="secondary"
                      style={{ marginTop: "10%", marginLeft: "25%" }}
                    />
                  </Grid>
                  <Grid size="grow">
                    <p>Hubo un error, por favor volver a intentar más tarde.</p>
                  </Grid>
                </Grid>
              </div>
            )}

            {messageExito === true && (
              <div
                style={{
                  backgroundColor: "#C2E3C3",
                  width: "100%",
                  marginBottom: "10px",
                }}
              >
                <Grid container sx={{ width: "100%" }}>
                  <Grid size={{ xs: 2 }}>
                    <CheckCircleOutlineSharpIcon
                      fontSize="large"
                      style={{
                        marginTop: "10%",
                        marginLeft: "25%",
                        color: "green",
                      }}
                    />
                  </Grid>
                  <Grid size="grow">
                    <p>Tu nueva contraseña se registró con éxito.</p>
                  </Grid>
                </Grid>
              </div>
            )}

            <br />
            {aceptar === true && (
              <Button
                style={{
                  alignSelf: "center",
                  textTransform: "none",
                  color: "white",
                  backgroundColor: "#B1B0AF",
                }}
                variant="contained"
                type="submit"
              >
                Aceptar
              </Button>
            )}
            {ingresar === true && (
              <Link
                to="/"
                style={{ textDecoration: "none", alignSelf: "center" }}
              >
                <Button
                  style={{
                    textTransform: "none",
                    color: "white",
                    backgroundColor: "#009BDB",
                  }}
                  variant="contained"
                >
                  Ingresar
                </Button>
              </Link>
            )}
          </form>
        </Container>
        <br />
      </div>
    </div>
  );
};
export default NuevaContraseña;
